<template>
    <div class="starqris-payment">
        <div v-if="loading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-2 text-muted small">Memuat QRIS...</p>
        </div>

        <div v-else-if="paid" class="text-center py-4">
            <i class="fas fa-check-circle text-success" style="font-size:48px"></i>
            <h5 class="mt-3 text-success">{{ successTitle }}</h5>
            <p class="text-muted">{{ successMessage }}</p>
            <button class="btn btn-primary mt-2" @click="$emit('done')">Selesai</button>
        </div>

        <div v-else-if="expired" class="text-center py-4">
            <i class="fas fa-clock text-warning" style="font-size:48px"></i>
            <h5 class="mt-3">QRIS Kadaluarsa</h5>
            <p class="text-muted">Silakan buat transaksi top up baru.</p>
            <button class="btn btn-secondary mt-2" @click="$emit('cancel')">Tutup</button>
        </div>

        <div v-else>
            <div class="text-center mb-3">
                <img v-if="qrImageSrc" :src="qrImageSrc" alt="QRIS" class="qris-img">
                <div v-else class="qris-fallback">
                    <i class="fas fa-qrcode fa-3x text-muted"></i>
                    <p class="small text-muted mt-2">QR tidak tersedia. Hubungi admin.</p>
                </div>
            </div>

            <div class="payment-info">
                <div class="info-row">
                    <span>Nominal Top Up</span>
                    <strong>{{ formatRp(data.amount) }}</strong>
                </div>
                <div class="info-row">
                    <span>Kode Unik</span>
                    <strong>+{{ formatRp(data.unique_code) }}</strong>
                </div>
                <div v-if="qrisFee > 0" class="info-row">
                    <span>Biaya QRIS</span>
                    <strong>+{{ formatRp(qrisFee) }}</strong>
                </div>
                <div class="info-row total">
                    <span>Total Bayar</span>
                    <strong class="text-primary">{{ formatRp(data.total_amount) }}</strong>
                </div>
            </div>

            <div class="alert alert-info small mt-3 mb-2">
                <i class="fas fa-info-circle"></i>
                Scan QRIS dengan aplikasi bank/e-wallet. Pastikan nominal <b>tepat</b> sesuai total di atas.
            </div>

            <div class="text-center">
                <div v-if="polling" class="small text-muted">
                    <span class="spinner-border spinner-border-sm mr-1"></span>
                    Menunggu pembayaran...
                </div>
                <button class="btn btn-outline-secondary btn-sm mt-2" @click="$emit('cancel')">Batal</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    props: {
        transactionId: { type: String, required: true },
        data: { type: Object, required: true },
        statusUrl: { type: String, default: '' },
        successTitle: { type: String, default: 'Pembayaran Berhasil!' },
        successMessage: { type: String, default: 'Saldo Anda telah ditambahkan.' },
    },
    data() {
        return {
            loading: false,
            polling: true,
            paid: false,
            expired: false,
            pollTimer: null,
        }
    },
    computed: {
        qrisFee() {
            return parseInt(this.data.qris_fee, 10) || 0
        },
        qrImageSrc() {
            if (this.data.qris_base64) return this.data.qris_base64
            if (this.data.qris_payload) {
                return 'https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=' + encodeURIComponent(this.data.qris_payload)
            }
            return ''
        },
    },
    mounted() {
        this.startPolling()
        if (this.data.expires_at) {
            const exp = new Date(this.data.expires_at).getTime()
            if (exp < Date.now()) this.expired = true
        }
    },
    beforeDestroy() {
        this.stopPolling()
    },
    methods: {
        formatRp(v) {
            const n = parseInt(v) || 0
            return 'Rp ' + n.toLocaleString('id-ID')
        },
        startPolling() {
            this.pollTimer = setInterval(this.checkStatus, 4000)
            this.checkStatus()
        },
        stopPolling() {
            if (this.pollTimer) {
                clearInterval(this.pollTimer)
                this.pollTimer = null
            }
            this.polling = false
        },
        async checkStatus() {
            if (this.paid || this.expired) return
            try {
                const url = this.statusUrl || ('payment/status/' + this.transactionId)
                const r = await axios.get(url)
                if (r.data && r.data.success) {
                    const st = r.data.data.status
                    if (st === 'success') {
                        this.paid = true
                        this.stopPolling()
                        this.$emit('paid')
                    } else if (st === 'failed') {
                        this.stopPolling()
                        this.$toast.error('Pembayaran gagal')
                        this.$emit('cancel')
                    }
                }
            } catch (e) { /* keep polling */ }
        },
    },
}
</script>

<style scoped>
.starqris-payment { max-width: 360px; margin: 0 auto; }
.qris-img {
    max-width: 240px; width: 100%; border: 1px solid #e9ebf6;
    border-radius: 12px; padding: 8px; background: #fff;
}
.qris-fallback {
    padding: 40px; background: #f8f9fb; border-radius: 12px;
}
.payment-info {
    background: #f8f9fb; border-radius: 10px; padding: 12px 16px;
}
.info-row {
    display: flex; justify-content: space-between; padding: 4px 0;
    font-size: 13px; color: #5b647a;
}
.info-row.total {
    border-top: 1px solid #e9ebf6; margin-top: 6px; padding-top: 8px;
    font-size: 14px;
}
</style>
